import { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  TextField,
  FormControlLabel,
  FormControl,
  Switch,
  Button,
  Autocomplete,
  Loading,
} from "../../../components";
import { notification, GrupoPessoasService } from "../../../services";
import { InputErros, value, PermisoesHelper } from "../../../helpers";
import { responseErros } from "../../../utils";
import grupoPessoasValidator from "./middlewares/grupo-pessoas.validator";
import { GrupoPessoas } from "./entities";

const AddGrupoPessoas = ({
  id,
  handleCloseDialog,
  openDialog,
  buscaGruposPessoas,
  tiposPessoaOptions,
}) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-pessoas-visualizar");
  const [loading, setLoading] = useState(false);
  const [grupoPessoas, setGrupoPessoas] = useState({ ativado: true });
  const [tipoPessoa, setTipoPessoa] = useState(null);
  const grupoPessoasService = new GrupoPessoasService();
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  useEffect(() => {
    if (openDialog) {
      if (!id) return;
      buscaGrupoPessoas();
    }
  }, [openDialog]);

  const buscaGrupoPessoas = async () => {
    setLoading(true);
    const { data } = await grupoPessoasService.getById(id);
    setGrupoPessoas(data);
    setTipoPessoa(data?.tipoPessoa);
    setLoading(false);
  };

  const handleInputChange = (e) => {
    e.persist();
    setGrupoPessoas((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const montarGrupoPessoas = () => {
    return {
      ...grupoPessoas,
      tipoPessoa: tipoPessoa ? tipoPessoa : null,
    };
  };

  const handleSubmit = async () => {
    const body = montarGrupoPessoas();
    const grupoPessoasDto = new GrupoPessoas(body);
    setLoading(true);
    grupoPessoasValidator
      .validate(grupoPessoasDto, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await grupoPessoasService.atualizar(
            id,
            grupoPessoasDto,
          );
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            handleCloseDialog();
            buscaGruposPessoas();
          } else responseErros(response);
        } else {
          const response = await grupoPessoasService.cadastrar(grupoPessoasDto);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            handleCloseDialog();
            buscaGruposPessoas();
          } else responseErros(response);
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  return (
    <Container>
      <Card className="p-3">
        <CardHeader
          title={
            grupoPessoas?.id
              ? "Editar grupo de pessoas"
              : "Cadastrar grupo de pessoas"
          }
          action={
            <FormControlLabel
              control={
                <Switch
                  checked={grupoPessoas?.ativado ? grupoPessoas.ativado : false}
                  onChange={() =>
                    setGrupoPessoas((prevState) => ({
                      ...prevState,
                      ativado: !grupoPessoas?.ativado,
                    }))
                  }
                  name="ativado"
                  color="primary"
                />
              }
              label={grupoPessoas?.ativado ? "Ativado" : "Desativado"}
            />
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={7}>
              <TextField
                id="nome"
                name="nome"
                label="Nome"
                variant="outlined"
                margin="normal"
                value={grupoPessoas?.nome ? grupoPessoas.nome : ""}
                onChange={(e) => {
                  setInputErro([]);
                  handleInputChange(e);
                }}
                InputProps={{
                  inputProps: { maxLength: 35 },
                }}
                fullWidth
                required
                error={inputErros.get("nome")}
              />
            </Grid>
            <Grid item xs={5}>
              <FormControl variant="outlined" margin="normal" fullWidth>
                <Autocomplete
                  required
                  id="tipoPessoa"
                  name="tipoPessoa"
                  options={tiposPessoaOptions}
                  noOptionsText="Sem opções"
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.descricao ? option.descricao : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipo de Pessoa"
                      variant="outlined"
                      error={inputErros.get("tipoPessoa")}
                      required
                      fullWidth
                    />
                  )}
                  onChange={(e, newValue) => {
                    e.persist();
                    setTipoPessoa(newValue?.id);
                    if (!newValue?.id) {
                      setGrupoPessoas((prevState) => ({
                        ...prevState,
                        tabelaPrecoId: null,
                      }));
                    }
                  }}
                  value={value.autoComplete(tiposPessoaOptions, tipoPessoa)}
                />
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            id="botaoSalvar"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            disabled={!permissoesHelper.temPermisao("grupo-pessoas-cadastrar")}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            {id ? "Atualizar" : "Salvar"}
          </Button>
          <Button
            color="inherit"
            variant="contained"
            onClick={handleCloseDialog}
          >
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </Container>
  );
};

export default AddGrupoPessoas;
